module.exports = __webpack_public_path__ + "img/application-pvc.981a30b1.jpg";